import React from 'react';
import './Sidebar.css';

function Sidebar({ currentPage, setCurrentPage, currentUser, onLogout, isOpen, onClose, isMobile }) {
  const menuItems = [
    { id: 'dashboard', label: '📊 Bảng Điều Khiển', icon: '📊' },
    { id: 'products', label: '📦 Sản Phẩm', icon: '📦' },
    { id: 'inventory', label: '📦 Tồn Kho', icon: '📋' },
    { id: 'customers', label: '👥 Khách Hàng', icon: '👥' },
    { id: 'orders', label: '🛒 Hóa Đơn', icon: '🛒' },
    { id: 'reports', label: '📈 Báo Cáo', icon: '📈' },
    ...(currentUser?.role === 'admin' ? [{ id: 'users', label: '🔐 Người Dùng', icon: '🔐' }] : [])
  ];

  return (
    <>
      {isMobile && (
        <button
          type="button"
          className={`sidebar-backdrop ${isOpen ? 'show' : ''}`}
          onClick={onClose}
          aria-label="Đóng menu điều hướng"
        />
      )}
      <aside className={`sidebar ${isMobile ? 'sidebar-mobile' : 'sidebar-desktop'} ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div>
            <h2>QLBH</h2>
            <p>Quản lý bán hàng đa nền tảng</p>
          </div>
          {isMobile && (
            <button type="button" className="sidebar-close" onClick={onClose} aria-label="Đóng menu">×</button>
          )}
        </div>
        <nav className="sidebar-menu">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`menu-item ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => setCurrentPage(item.id)}
            >
              <span className="menu-icon">{item.icon}</span>
              <span className="menu-label">{item.label}</span>
            </button>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-user-name">{currentUser?.full_name}</div>
          <div className="sidebar-user-role">{currentUser?.role === 'admin' ? 'Quản trị viên' : 'Nhân viên'}</div>
          <button type="button" className="sidebar-logout-btn" onClick={onLogout}>Đăng xuất</button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
